export const groupRooms = rooms => {
	if (!rooms || rooms.length === 0) {
		return [];
	}

	const groupedRooms = {};

	rooms.forEach(room => {
		// Créer une clé unique basée sur le titre et la composition (occupancy + area)
		const occupancyKey = `adults:${room.occupancy?.adults || 0}-children:${
			room.occupancy?.children || 0
		}-babies:${room.occupancy?.babies || 0}`;
		const areaKey = `area:${room.area?.value || 0}-${room.area?.unit || ""}`;
		const groupKey = `${room.label}|${occupancyKey}|${areaKey}`;

		if (groupedRooms[groupKey]) {
			// Si la chambre existe déjà, augmenter la quantité
			groupedRooms[groupKey].quantity += room.quantity ?? 1;
		} else {
			// Sinon, ajouter la chambre avec sa quantité initiale
			groupedRooms[groupKey] = {
				...room,
				quantity: room.quantity ?? 1,
			};
		}
	});

	return Object.values(groupedRooms);
};
